import { useContext } from 'react';
import { QUICK_VIEW_TYPES } from './QuickView';
import QuickViewContext, { QuickViewProvider } from './QuickViewContext';

const useQuickView = () => useContext(QuickViewContext);

export default useQuickView;
export { QuickViewProvider, QUICK_VIEW_TYPES };
